import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4">
      <div className="text-center">
        <h1 className="text-9xl font-extrabold text-[#EF5D22]">404</h1>
        <div className="bg-[#EF5D22] px-2 text-sm rounded rotate-12 absolute">
          Page Not Found
        </div>
        <h2 className="text-3xl font-bold text-gray-900 mt-8 mb-4">Looks like you're lost.</h2>
        <p className="text-gray-600 mb-12 max-w-md mx-auto">
          The page you are looking for doesn't exist or has been moved. 
          Let's get you back on track.
        </p>
        <Link 
          to="/" 
          className="bg-[#EF5D22] text-white px-10 py-4 rounded-xl font-bold text-lg inline-block shadow-xl hover:bg-[#d9541a] transition transform hover:-translate-y-1"
        >
          Go Back Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
